document.addEventListener('DOMContentLoaded', function () {
  
    function initGravityForm() {
      const formWrapper = document.querySelector('.gform_wrapper');
      if (!formWrapper) return; // no form, exit early
  
      const inputs = formWrapper.querySelectorAll('.gfield input, .gfield textarea');
  
      inputs.forEach(function (input) {
        if (input.value.trim() !== '') {
          input.parentElement.parentElement.classList.add('filled');
        }
  
        input.addEventListener('input', function () {
          if (input.value.trim() !== '') {
            input.parentElement.parentElement.classList.add('filled');
          } else {
            input.parentElement.parentElementclassList.remove('filled');
          }
        });
      });
    }
  
    // Run immediately if form is already there
    initGravityForm();
  
    // Keep checking for dynamically injected form for up to 5 seconds
    const observerInterval = setInterval(() => {
      if (document.querySelector('.gform_wrapper')) {
        clearInterval(observerInterval);
        initGravityForm();
      }
    }, 300);
  });
  